import React from "react";
import { useNavigate } from "react-router-dom";

const services = [
{
  id: "ride",
  icon: "🚖",
  title: "Ride-Hailing",
  subtitle: "Get there in minutes",
  description: "Book a bike, boda boda, tuk tuk, or car instantly. Real-time tracking, upfront pricing, no surprises.",
  color: "#ffd700",
  bgGradient: "linear-gradient(135deg, rgba(255,215,0,0.12) 0%, rgba(255,215,0,0.03) 100%)",
  borderColor: "rgba(255,215,0,0.25)",
  features: ["Real-time GPS tracking", "Upfront pricing", "4 vehicle types", "Rated drivers"]
},
{
  id: "parcel",
  icon: "📦",
  title: "Parcel Delivery",
  subtitle: "Same-day delivery",
  description: "Send packages across the city with live tracking and proof of delivery. Fragile items handled with care.",
  color: "#60a5fa",
  bgGradient: "linear-gradient(135deg, rgba(96,165,250,0.12) 0%, rgba(96,165,250,0.03) 100%)",
  borderColor: "rgba(96,165,250,0.25)",
  features: ["Same-day delivery", "POD confirmation", "Fragile item care"]
},
{
  id: "food",
  icon: "🍔",
  title: "Food Delivery",
  subtitle: "Hot meals, fast",
  description: "Order from your favorite local restaurants. Delivered hot and fresh in under 30 minutes.",
  color: "#f97316",
  bgGradient: "linear-gradient(135deg, rgba(249,115,22,0.12) 0%, rgba(249,115,22,0.03) 100%)",
  borderColor: "rgba(249,115,22,0.25)",
  features: ["500+ restaurants", "30-min delivery", "Live order tracking"]
},
{
  id: "car-hire",
  icon: "🚗",
  title: "Car Hire",
  subtitle: "Self-drive & chauffeur",
  description: "Browse verified vehicles for self-drive or with a professional chauffeur. Daily and weekly rates.",
  color: "#34d399",
  bgGradient: "linear-gradient(135deg, rgba(52,211,153,0.12) 0%, rgba(52,211,153,0.03) 100%)",
  borderColor: "rgba(52,211,153,0.25)",
  features: ["Self-drive & chauffeur", "Verified vehicles", "Flexible duration", "Deposit protection"],
  path: "/car-hire-listing"
},
{
  id: "corporate",
  icon: "🏢",
  title: "Corporate Leasing",
  subtitle: "Fleet solutions for business",
  description: "Monthly vehicle leasing for companies. Dedicated fleet, chauffeur options, and maintenance bundles.",
  color: "#a78bfa",
  bgGradient: "linear-gradient(135deg, rgba(167,139,250,0.12) 0%, rgba(167,139,250,0.03) 100%)",
  borderColor: "rgba(167,139,250,0.25)",
  features: ["Monthly billing", "Dedicated fleet", "Maintenance included", "Corporate dashboard"],
  path: "/corporate-leasing"
}];


const vehicles = [
{ emoji: "🚲", name: "Bicycle", price: "From KES 80", color: "#34d399" },
{ emoji: "🏍️", name: "Boda Boda", price: "From KES 150", color: "#ffd700", featured: true },
{ emoji: "🛺", name: "Tuk Tuk", price: "From KES 200", color: "#f97316" },
{ emoji: "🚗", name: "Car", price: "From KES 400", color: "#60a5fa" }];


const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <section id="services" className="py-24 relative overflow-hidden" style={{ background: "#0d1f3c" }}>
      {/* Background texture */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,215,0,1) 1px, transparent 0)",
          backgroundSize: "48px 48px"
        }} />

      <div
        className="absolute top-0 left-0 w-1/3 h-full opacity-10"
        style={{ background: "radial-gradient(ellipse at 0% 50%, #ffd700 0%, transparent 70%)" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-16">
          <div
            className="inline-flex items-center gap-2 rounded-full px-4 py-2 mb-5 border"
            style={{ background: "rgba(255,215,0,0.08)", borderColor: "rgba(255,215,0,0.2)" }}>

            <span className="text-[#ffd700] text-sm font-semibold">What We Offer</span>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <h2
              className="text-4xl lg:text-6xl font-black text-white leading-tight"
              style={{ fontFamily: "'DM Sans', sans-serif" }}>

              One App.
              <br />
              <span className="text-[#ffd700]">Every Journey.</span>
            </h2>
            <p className="text-white/45 text-lg max-w-sm">From your morning commute to your business deliveries .
OnTheGo handles it all across Africa.
            </p>
          </div>
        </div>

        {/* Bento Grid — 5 services */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
          {/* Ride-Hailing — large card */}
          <div
            onClick={() => navigate("/customer-booking-screen")}
            className="md:col-span-2 rounded-3xl p-8 border relative overflow-hidden group cursor-pointer transition-all duration-500 hover:scale-[1.02]"
            style={{ background: services?.[0]?.bgGradient, borderColor: services?.[0]?.borderColor }}>

            <div className="absolute -bottom-4 -right-4 text-[10rem] opacity-[0.07] select-none pointer-events-none leading-none">
              {services?.[0]?.icon}
            </div>
            <div className="relative z-10">
              <div className="text-5xl mb-5">{services?.[0]?.icon}</div>
              <div className="text-xs font-bold tracking-widest uppercase mb-2" style={{ color: services?.[0]?.color }}>
                {services?.[0]?.subtitle}
              </div>
              <h3 className="text-3xl font-black text-white mb-3">{services?.[0]?.title}</h3>
              <p className="text-white/55 text-base leading-relaxed max-w-sm mb-6">{services?.[0]?.description}</p>
              <div className="flex flex-wrap gap-2">
                {services?.[0]?.features?.map((f) =>
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-full text-xs font-semibold"
                  style={{
                    background: `${services?.[0]?.color}18`,
                    color: services?.[0]?.color,
                    border: `1px solid ${services?.[0]?.color}28`
                  }}>

                    ✓ {f}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Parcel Delivery */}
          <div
            onClick={() => navigate("/customer-booking-screen")}
            className="rounded-3xl p-7 border relative overflow-hidden group cursor-pointer transition-all duration-500 hover:scale-[1.03]"
            style={{ background: services?.[1]?.bgGradient, borderColor: services?.[1]?.borderColor }}>

            <div className="absolute -bottom-2 -right-2 text-7xl opacity-[0.07] select-none pointer-events-none leading-none">
              {services?.[1]?.icon}
            </div>
            <div className="relative z-10">
              <div className="text-4xl mb-4">{services?.[1]?.icon}</div>
              <div className="text-xs font-bold tracking-widest uppercase mb-1.5" style={{ color: services?.[1]?.color }}>
                {services?.[1]?.subtitle}
              </div>
              <h3 className="text-xl font-black text-white mb-2">{services?.[1]?.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4">{services?.[1]?.description}</p>
              <div className="flex flex-col gap-1.5">
                {services?.[1]?.features?.map((f) =>
                <div key={f} className="flex items-center gap-2 text-xs" style={{ color: services?.[1]?.color }}>
                    <span>→</span>
                    <span className="text-white/60">{f}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Food Delivery */}
          <div
            onClick={() => navigate("/customer-booking-screen")}
            className="rounded-3xl p-7 border relative overflow-hidden group cursor-pointer transition-all duration-500 hover:scale-[1.03]"
            style={{ background: services?.[2]?.bgGradient, borderColor: services?.[2]?.borderColor }}>

            <div className="absolute -bottom-2 -right-2 text-7xl opacity-[0.07] select-none pointer-events-none leading-none">
              {services?.[2]?.icon}
            </div>
            <div className="relative z-10">
              <div className="text-4xl mb-4">{services?.[2]?.icon}</div>
              <div className="text-xs font-bold tracking-widest uppercase mb-1.5" style={{ color: services?.[2]?.color }}>
                {services?.[2]?.subtitle}
              </div>
              <h3 className="text-xl font-black text-white mb-2">{services?.[2]?.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4">{services?.[2]?.description}</p>
              <div className="flex flex-col gap-1.5">
                {services?.[2]?.features?.map((f) =>
                <div key={f} className="flex items-center gap-2 text-xs" style={{ color: services?.[2]?.color }}>
                    <span>→</span>
                    <span className="text-white/60">{f}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Car Hire — new */}
          <div
            onClick={() => navigate("/car-hire-listing")}
            className="rounded-3xl p-7 border relative overflow-hidden group cursor-pointer transition-all duration-500 hover:scale-[1.03]"
            style={{ background: services?.[3]?.bgGradient, borderColor: services?.[3]?.borderColor }}>

            <div className="absolute -bottom-2 -right-2 text-7xl opacity-[0.07] select-none pointer-events-none leading-none">
              {services?.[3]?.icon}
            </div>
            <div className="relative z-10">
              <div className="text-4xl mb-4">{services?.[3]?.icon}</div>
              <div className="text-xs font-bold tracking-widest uppercase mb-1.5" style={{ color: services?.[3]?.color }}>
                {services?.[3]?.subtitle}
              </div>
              <h3 className="text-xl font-black text-white mb-2">{services?.[3]?.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4">{services?.[3]?.description}</p>
              <div className="flex flex-col gap-1.5">
                {services?.[3]?.features?.map((f) =>
                <div key={f} className="flex items-center gap-2 text-xs" style={{ color: services?.[3]?.color }}>
                    <span>→</span>
                    <span className="text-white/60">{f}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Corporate Leasing — new, spans 2 cols */}
          <div
            onClick={() => navigate("/corporate-leasing")}
            className="md:col-span-2 rounded-3xl p-8 border relative overflow-hidden group cursor-pointer transition-all duration-500 hover:scale-[1.02]"
            style={{ background: services?.[4]?.bgGradient, borderColor: services?.[4]?.borderColor }}>

            <div className="absolute -bottom-4 -right-4 text-[10rem] opacity-[0.07] select-none pointer-events-none leading-none">
              {services?.[4]?.icon}
            </div>
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold mb-4" style={{ background: `${services?.[4]?.color}15`, color: services?.[4]?.color, border: `1px solid ${services?.[4]?.color}25` }}>
                🏢 B2B Fleet Solutions
              </div>
              <div className="text-5xl mb-4">{services?.[4]?.icon}</div>
              <div className="text-xs font-bold tracking-widest uppercase mb-2" style={{ color: services?.[4]?.color }}>
                {services?.[4]?.subtitle}
              </div>
              <h3 className="text-3xl font-black text-white mb-3">{services?.[4]?.title}</h3>
              <p className="text-white/55 text-base leading-relaxed max-w-sm mb-6">{services?.[4]?.description}</p>
              <div className="flex flex-wrap gap-2">
                {services?.[4]?.features?.map((f) =>
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-full text-xs font-semibold"
                  style={{
                    background: `${services?.[4]?.color}18`,
                    color: services?.[4]?.color,
                    border: `1px solid ${services?.[4]?.color}28`
                  }}>

                    ✓ {f}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* List Your Car CTA */}
        <div
          className="rounded-3xl p-8 border flex flex-col sm:flex-row items-center justify-between gap-6"
          style={{ background: "rgba(255,215,0,0.05)", borderColor: "rgba(255,215,0,0.2)" }}>

          <div>
            <div className="text-3xl mb-2">🔑</div>
            <h3 className="text-white font-black text-xl mb-1">Own a Vehicle? Earn with OnTheGo</h3>
            <p className="text-white/50 text-sm">List your car and earn KES 45,000+ per month. We handle bookings, payments, and support.</p>
          </div>
          <button
            onClick={() => navigate("/list-my-car")}
            className="flex-shrink-0 px-8 py-4 rounded-2xl font-black text-sm transition-all hover:scale-[1.03]"
            style={{ background: "rgba(255,215,0,0.15)", color: "#ffd700", border: "1px solid rgba(255,215,0,0.3)" }}>

            List Your Car →
          </button>
        </div>
      </div>
    </section>);

};

export default ServicesSection;